export default "__VITE_ASSET__Ct47Nyu6__"